function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import _ from 'lodash';
import moment from 'moment';
import { removeTypename } from 'shared/helpers/utils';
import { findNextOpenDay, guessTimezone } from 'shared/helpers/date-time';
import { CanadianDefaultRewardsProgramDescription, CanadianDefaultRewardsProgramEnrollment, CanadianDefaultRewardsProgramName, DefaultRewardsProgramDescription, DefaultRewardsProgramEnrollment, DefaultRewardsProgramName } from '../../constants/dispensaries';
import { getComplianceConfig } from '../compliance';
var getOpenInfo = function(param) {
    var serviceType = param.serviceType, timezone = param.timezone, standardHours = param.standardHours, specialHours = param.specialHours, isServiceOffered = param.isServiceOffered;
    var defaultOpenInfo = {
        isOpen: false,
        isClosed: true,
        nextService: {
            openMoment: null,
            openString: "Time unknown",
            closeMoment: null
        }
    };
    if (!isServiceOffered) {
        return defaultOpenInfo;
    }
    timezone = timezone || guessTimezone();
    var now = moment().tz(timezone);
    var nextOpenDay = findNextOpenDay({
        serviceType: serviceType,
        standardHours: standardHours,
        specialHours: specialHours,
        timezone: timezone,
        now: now
    });
    if (!nextOpenDay || _.keys(nextOpenDay).length === 0) {
        return defaultOpenInfo;
    }
    var date = nextOpenDay.date, openMoment = nextOpenDay.openMoment, closeMoment = nextOpenDay.closeMoment;
    var nextDayString = "on ".concat(date.format('dddd'));
    if (date.isSame(now, 'day')) {
        nextDayString = 'today';
    }
    var openString = "".concat(openMoment.format('h:mmA'), " ").concat(nextDayString);
    var isOpen = now.isBetween(openMoment, closeMoment);
    return {
        isOpen: isOpen,
        isClosed: !isOpen,
        nextService: {
            openMoment: openMoment,
            closeMoment: closeMoment,
            openString: openString
        }
    };
};
/**
 * @param {Dispensary} dispensary
 * @returns {boolean}
 */ export var isRecMed = function(param) {
    var medicalDispensary = param.medicalDispensary, recDispensary = param.recDispensary;
    return !!medicalDispensary && !!recDispensary;
};
export var hasIsolatedMenus = function() {
    var dispensary = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var location = dispensary.location, storeSettings = dispensary.storeSettings;
    return (storeSettings === null || storeSettings === void 0 ? void 0 : storeSettings.isolatedMenus) || isRecMed(dispensary) && getComplianceConfig(location === null || location === void 0 ? void 0 : location.state, 'isolatedMenus');
};
/**
 * @typedef {{recDispensary?: boolean | null, medicalDispensary?: boolean | null}} Dispensary
 */ /**
 * @param {Dispensary} dispensary
 * @returns {boolean}
 */ export var isMedOnly = function(param) {
    var medicalDispensary = param.medicalDispensary, recDispensary = param.recDispensary;
    return !!medicalDispensary && !recDispensary;
};
/**
 * @param {Dispensary} dispensary
 * @returns {boolean}
 */ export var isRecOnly = function(param) {
    var medicalDispensary = param.medicalDispensary, recDispensary = param.recDispensary;
    return !medicalDispensary && !!recDispensary;
};
/**
 * Checks if loyalty points should be hidden for a rec dispensary based on state compliance rules.
 * @param {Dispensary} dispensary
 * @returns {boolean}
 */ export var shouldHideLoyaltyPointsForRec = function(dispensary) {
    var _dispensary_location;
    if (!dispensary || !dispensary.recDispensary) {
        return false;
    }
    var state = dispensary === null || dispensary === void 0 ? void 0 : (_dispensary_location = dispensary.location) === null || _dispensary_location === void 0 ? void 0 : _dispensary_location.state;
    return !!getComplianceConfig(state, 'recHideLoyaltyPoints');
};
export var getDefaultRewardsProgramDisplayDescription = function(param) {
    var _param_location = param.location, location = _param_location === void 0 ? {} : _param_location;
    return (location === null || location === void 0 ? void 0 : location.country) === 'Canada' ? CanadianDefaultRewardsProgramDescription : DefaultRewardsProgramDescription;
};
export var getDefaultRewardsProgramDisplayEnrollment = function(param) {
    var _param_location = param.location, location = _param_location === void 0 ? {} : _param_location;
    return (location === null || location === void 0 ? void 0 : location.country) === 'Canada' ? CanadianDefaultRewardsProgramEnrollment : DefaultRewardsProgramEnrollment;
};
export var getDefaultRewardsProgramDisplayName = function(param) {
    var _param_location = param.location, location = _param_location === void 0 ? {} : _param_location;
    return (location === null || location === void 0 ? void 0 : location.country) === 'Canada' ? CanadianDefaultRewardsProgramName : DefaultRewardsProgramName;
};
export function requiresCustomerState(dispensary) {
    var _dispensary_location;
    return !!getComplianceConfig(dispensary === null || dispensary === void 0 ? void 0 : (_dispensary_location = dispensary.location) === null || _dispensary_location === void 0 ? void 0 : _dispensary_location.state, 'outOfStateLimits');
}
/**
 * Javascript date has no internal knowledge about
 * timezone whereas moment does.  We are only going
 * to use moment in these calculations for that reason.
 * @returns {Record<string, { isOpen: boolean, isClosed: boolean, nextService: { openMoment: string | null, openString: string, closeMoment: string | null } }>}
 */ export function openInfoForDispensary(dispensary) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref__previewMode = _ref._previewMode, _previewMode = _ref__previewMode === void 0 ? false : _ref__previewMode;
    var orderTypes = [
        'inStorePickup',
        'curbsidePickup',
        'driveThruPickup',
        'delivery'
    ];
    var openInfo = {};
    _.forEach(orderTypes, function(orderType) {
        var defaultOpenInfo = {
            isOpen: true,
            isClosed: false,
            nextService: {
                openMoment: null,
                openString: "Time unknown",
                closeMoment: null
            }
        };
        _.set(openInfo, orderType, defaultOpenInfo);
    });
    if (!dispensary) {
        return openInfo;
    }
    var timezone = dispensary.timezone, hoursSettings = dispensary.hoursSettings;
    var enabledOrderTypes = getEnabledV2OrderTypes(dispensary);
    _.forEach(orderTypes, function(orderType) {
        var _hoursSettings_orderType;
        var hoursSettingsForOrderType = (_hoursSettings_orderType = hoursSettings === null || hoursSettings === void 0 ? void 0 : hoursSettings[orderType]) !== null && _hoursSettings_orderType !== void 0 ? _hoursSettings_orderType : {};
        _.set(openInfo, orderType, getOpenInfo({
            serviceType: orderType,
            timezone: timezone,
            standardHours: hoursSettingsForOrderType.hours,
            specialHours: hoursSettingsForOrderType.specialHours,
            isServiceOffered: _.includes(enabledOrderTypes, orderType)
        }));
    });
    return openInfo;
}
export function checkDeliveryOpenInfo(openInfoForOrderTypes, dispensary) {
    var _dispensary_orderTypesConfigV2_delivery_scheduledOrderingConfigV2, _dispensary_orderTypesConfigV2_delivery, _dispensary_orderTypesConfigV2;
    var _dispensary_orderTypesConfigV2_delivery_scheduledOrderingConfigV2_sameDayDeliveryEnabled;
    var sameDayDeliveryEnabled = (_dispensary_orderTypesConfigV2_delivery_scheduledOrderingConfigV2_sameDayDeliveryEnabled = dispensary === null || dispensary === void 0 ? void 0 : (_dispensary_orderTypesConfigV2 = dispensary.orderTypesConfigV2) === null || _dispensary_orderTypesConfigV2 === void 0 ? void 0 : (_dispensary_orderTypesConfigV2_delivery = _dispensary_orderTypesConfigV2.delivery) === null || _dispensary_orderTypesConfigV2_delivery === void 0 ? void 0 : (_dispensary_orderTypesConfigV2_delivery_scheduledOrderingConfigV2 = _dispensary_orderTypesConfigV2_delivery.scheduledOrderingConfigV2) === null || _dispensary_orderTypesConfigV2_delivery_scheduledOrderingConfigV2 === void 0 ? void 0 : _dispensary_orderTypesConfigV2_delivery_scheduledOrderingConfigV2.sameDayDeliveryEnabled) !== null && _dispensary_orderTypesConfigV2_delivery_scheduledOrderingConfigV2_sameDayDeliveryEnabled !== void 0 ? _dispensary_orderTypesConfigV2_delivery_scheduledOrderingConfigV2_sameDayDeliveryEnabled : true;
    if ((openInfoForOrderTypes === null || openInfoForOrderTypes === void 0 ? void 0 : openInfoForOrderTypes.delivery) && !sameDayDeliveryEnabled) {
        openInfoForOrderTypes.delivery.isOpen = false;
        openInfoForOrderTypes.delivery.isClosed = true;
    }
    return openInfoForOrderTypes;
}
/**
 * @param {Dispensary} dispensary
 * @returns {Array<string>}
 */ export function getEnabledV2OrderTypes(dispensary) {
    if (!dispensary || !dispensary.enabledOrderTypes && !dispensary.orderTypesConfig) {
        return [];
    }
    var enabledOrderTypes = dispensary.enabledOrderTypes, orderTypesConfig = dispensary.orderTypesConfig;
    // Helper is being called from the API and doesn't have
    // access to the serialized enabledOrderTypes field, use
    // the orderTypesConfig Mongo data instead
    if (!enabledOrderTypes) {
        var orderTypes = _object_spread_props(_object_spread({}, _.omit(removeTypename(orderTypesConfig), [
            'pickup',
            'kiosk',
            '_id'
        ]) || {}), {
            inStorePickup: orderTypesConfig.pickup
        });
        return _.filter(_.keys(orderTypes), function(orderType) {
            var _orderTypes_orderType = orderTypes[orderType], enabled = _orderTypes_orderType.enabled, enableASAPOrdering = _orderTypes_orderType.enableASAPOrdering, enableScheduledOrdering = _orderTypes_orderType.enableScheduledOrdering;
            return enabled && (enableASAPOrdering || enableScheduledOrdering);
        });
    }
    // Helper is being called from the client and can use the
    // serialized enabledOrderTypes field on the dispensary
    var orderTypes1 = _.omit(removeTypename(enabledOrderTypes), [
        'pickup',
        'kiosk'
    ]) || {};
    return _.filter(_.keys(orderTypes1), function(orderType) {
        return orderTypes1[orderType];
    });
}
export function areSpecialHoursToday(dispensary) {
    var hoursSettings = dispensary.hoursSettings, _dispensary_specialHours = dispensary.specialHours, specialHours = _dispensary_specialHours === void 0 ? {} : _dispensary_specialHours;
    var today = moment().format('YYYY-MM-DD');
    if (!hoursSettings || !specialHours) {
        return false;
    }
    var checkSpecialHours = function(specialHourArr) {
        if (specialHourArr === null || specialHourArr === void 0 ? void 0 : specialHourArr.length) {
            var isDuringSpecialHours = _.some(specialHourArr, function(specialHour) {
                var startDate = specialHour.startDate, endDate = specialHour.endDate;
                var startMoment = moment(startDate);
                var endMoment = moment(endDate);
                return startMoment.isSameOrBefore(today, 'day') && endMoment.isSameOrAfter(today, 'day');
            });
            return isDuringSpecialHours;
        }
        return false;
    };
    if (hoursSettings) {
        var _hoursSettings_inStorePickup = hoursSettings.inStorePickup, tmp = _hoursSettings_inStorePickup.specialHours, inStoreSpecialHours = tmp === void 0 ? {} : tmp, _hoursSettings_curbsidePickup = hoursSettings.curbsidePickup, tmp1 = _hoursSettings_curbsidePickup.specialHours, curbsideSpecialHours = tmp1 === void 0 ? {} : tmp1, _hoursSettings_driveThruPickup = hoursSettings.driveThruPickup, tmp2 = _hoursSettings_driveThruPickup.specialHours, driveThruSpecialHours = tmp2 === void 0 ? {} : tmp2, _hoursSettings_delivery = hoursSettings.delivery, tmp3 = _hoursSettings_delivery.specialHours, deliverySpecialHours = tmp3 === void 0 ? {} : tmp3;
        var allSpecialHours = _.concat(inStoreSpecialHours, curbsideSpecialHours, driveThruSpecialHours, deliverySpecialHours);
        return checkSpecialHours(allSpecialHours);
    }
    return checkSpecialHours(specialHours);
}
export function collectScheduledData(dispensary, orderType, schedulingOption, reservationSlots) {
    var _openInfo_currentOrderType, _dispensary_orderTypesConfigV2_currentOrderType, _dispensary_orderTypesConfigV2_currentOrderType1, _openInfo_currentOrderType1, _nextService_openMoment, _nextService_closeMoment;
    var openInfo = openInfoForDispensary(dispensary);
    var currentOrderType = orderType !== null && orderType !== void 0 ? orderType : _.findKey(openInfo, "isOpen");
    var nextService = (_openInfo_currentOrderType = openInfo[currentOrderType]) === null || _openInfo_currentOrderType === void 0 ? void 0 : _openInfo_currentOrderType.nextService;
    var scheduledOrderingEnabled = dispensary === null || dispensary === void 0 ? void 0 : (_dispensary_orderTypesConfigV2_currentOrderType = dispensary.orderTypesConfigV2[currentOrderType]) === null || _dispensary_orderTypesConfigV2_currentOrderType === void 0 ? void 0 : _dispensary_orderTypesConfigV2_currentOrderType.enableScheduledOrdering;
    var afterHoursEnabled = dispensary === null || dispensary === void 0 ? void 0 : (_dispensary_orderTypesConfigV2_currentOrderType1 = dispensary.orderTypesConfigV2[currentOrderType]) === null || _dispensary_orderTypesConfigV2_currentOrderType1 === void 0 ? void 0 : _dispensary_orderTypesConfigV2_currentOrderType1.enableAfterHoursOrdering;
    var afterHoursInEffect = ((_openInfo_currentOrderType1 = openInfo[currentOrderType]) === null || _openInfo_currentOrderType1 === void 0 ? void 0 : _openInfo_currentOrderType1.isClosed) && afterHoursEnabled;
    if (currentOrderType === 'delivery') {
        afterHoursEnabled = afterHoursEnabled && scheduledOrderingEnabled;
    }
    return {
        dispensaryId: dispensary === null || dispensary === void 0 ? void 0 : dispensary.id,
        orderType: currentOrderType,
        orderTypeHours: removeTypename(dispensary === null || dispensary === void 0 ? void 0 : dispensary.hoursSettings[currentOrderType]),
        orderTypeOpenInfo: _object_spread_props(_object_spread({}, openInfo[currentOrderType]), {
            nextService: _object_spread_props(_object_spread({}, nextService), {
                openMoment: nextService === null || nextService === void 0 ? void 0 : (_nextService_openMoment = nextService.openMoment) === null || _nextService_openMoment === void 0 ? void 0 : _nextService_openMoment.format(),
                closeMoment: nextService === null || nextService === void 0 ? void 0 : (_nextService_closeMoment = nextService.closeMoment) === null || _nextService_closeMoment === void 0 ? void 0 : _nextService_closeMoment.format()
            })
        }),
        scheduledOrderingEnabled: scheduledOrderingEnabled,
        afterHoursEnabled: afterHoursEnabled,
        afterHoursInEffect: afterHoursInEffect,
        schedulingOption: schedulingOption,
        reservationSlots: reservationSlots
    };
}
